import { instance } from "./axios";

export const updatePackingMeasurement = (payload, id) => {
  try {
    return instance.put(`/visit/packing/${id}`, payload);
  } catch (error) {
    throw error;
  }
};
